import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";

// Shared prefix for all Booking & Volume Performance endpoints
// (…/booking-volume-performance/booking-volume). Callers pass the endpoint
// path (e.g. "/summary?…"); query-string / param building is a component
// concern and lives in the composables.
const baseURL = `${import.meta.env.VITE_API_BASE_URL}/booking-volume-performance/booking-volume`;

const getAll = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("get", url, config);
};

export default { getAll };
